(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function() {
    function parseEasternToUtc(ts) {
      if (!ts) return null;
      var parts = ts.trim().split(' ');
      if (parts.length !== 2) return null;

      var datePart = parts[0];
      var timePart = parts[1];

      var dateBits = datePart.split('-');
      var timeBits = timePart.split(':');

      if (dateBits.length !== 3 || timeBits.length < 2) return null;

      var year = parseInt(dateBits[0], 10);
      var month = parseInt(dateBits[1], 10) - 1; // 0-based month
      var day = parseInt(dateBits[2], 10);

      var hour = parseInt(timeBits[0], 10);
      var minute = parseInt(timeBits[1], 10);
      var second = timeBits.length > 2 ? parseInt(timeBits[2], 10) : 0;

      if (
        isNaN(year) || isNaN(month) || isNaN(day) ||
        isNaN(hour) || isNaN(minute) || isNaN(second)
      ) {
        return null;
      }

      // input is est, grabs utc and add 5. may need to readjust for DST?
      // uhmmm... dont think so
      // gah
      return Date.UTC(year, month, day, hour + 5, minute, second);
    }

    function initCountdown(timerEl) {
      var targetString = timerEl.getAttribute('data-target-est');
      if (!targetString) return;

      var targetUtc = parseEasternToUtc(targetString);
      if (targetUtc === null) return;

      var daysEl = timerEl.querySelector('[data-days]');
      var hoursEl = timerEl.querySelector('[data-hours]');
      var minutesEl = timerEl.querySelector('[data-minutes]');
      var secondsEl = timerEl.querySelector('[data-seconds]');
      var hideDays = timerEl.hasAttribute('data-hide-days');

      function update() {
        var now = new Date();
        var diff = targetUtc - now.getTime();

        if (diff <= 0) {
          if (daysEl && !hideDays) daysEl.textContent = '0';
          if (hoursEl) {
            if (hideDays) {
              hoursEl.textContent = '0';
            } else {
              hoursEl.textContent = '00';
            }
          }
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (!hideDays && daysEl) {
          daysEl.textContent = String(days);
        }
        if (hoursEl) {
          // If days are hidden, convert days to hours and add to hours count
          if (hideDays) {
            var totalHours = (days * 24) + hours;
            hoursEl.textContent = String(totalHours);
          } else {
            hoursEl.textContent = String(hours).padStart(2, '0');
          }
        }
        if (minutesEl) {
          minutesEl.textContent = String(minutes).padStart(2, '0');
        }
        if (secondsEl) {
          secondsEl.textContent = String(seconds).padStart(2, '0');
        }
      }

      update();
      setInterval(update, 1000);
    }

    document.addEventListener('DOMContentLoaded', function() {
      var timers = document.querySelectorAll('[data-countdown-est]');
      if (!timers.length) return;
      timers.forEach(initCountdown);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
